import { Fade, Grid, Paper } from '@mui/material'
import React, { useEffect } from 'react'
import { useWorkOrderState } from '../../../hooks'
import { WorkOrderReportDashboard } from '../../../interfaces'
import { DonutChart2 } from '../../Charts/DonutChart/DonutChart2'

interface WorkOrderGraphicProps {
  workOrderData: WorkOrderReportDashboard[]
}

export const WorkOrderGraphic: React.FC<WorkOrderGraphicProps> = ({
  workOrderData
}) => {
  const {
    workOrderStatesState: { workOrderStates },
    getWorkOrderStates
  } = useWorkOrderState()

  useEffect(() => {
    if (workOrderStates?.length === 0) {
      getWorkOrderStates()
    }
  }, [])

  const getWorkOrderStateText = (id: number): string => {
    if (workOrderStates === undefined || workOrderStates.length === 0) return ''

    return workOrderStates?.filter((item) => item.workOrderStateId === id)[0]
      .state
  }

  const labels: string[] = workOrderData.map((wod: WorkOrderReportDashboard) =>
    getWorkOrderStateText(wod.workOrderStateId)
  )

  const series: number[] = workOrderData.map(
    (wod: WorkOrderReportDashboard) => wod.qty
  )

  const responsive: ApexResponsive[] = [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          show: false
        },
        chart: {
          width: '100%',
          height: '100%'
        }
      }
    },
    {
      breakpoint: 1000,
      options: {
        legend: {
          position: 'bottom'
        },
        chart: {
          width: '100%',
          height: '100%'
        }
      }
    }
  ]

  return (
    <Paper
      elevation={3}
      style={{ padding: '10px', marginTop: '20px', minHeight: '300px' }}
    >
      <Fade in={true}>
        <Grid container spacing={0} direction='row'>
          <Grid item sm={12}>
            <DonutChart2
              options={{
                labels: labels,
                responsive,
                colors: [
                  '#5DADE2',
                  '#48C9B0',
                  '#F4D03F',
                  '#AF7AC5',
                  '#EC7063',
                  '#5D6D7E',
                  '#01B656'
                ]
              }}
              series={series}
            />
          </Grid>
        </Grid>
      </Fade>
    </Paper>
  )
}
